(() => {
  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  function getQty(form) {
    const qty = form.querySelector('input[name="quantity"]');
    return qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes('/cart/add')) return;

    const addonWrap = document.querySelector('[data-tcg-addon="gasket"]');
    if (!addonWrap) return;

    const cb = addonWrap.querySelector('.tcgAddGasket');
    const dd = addonWrap.querySelector('.tcgGasketVariant');

    if (!cb || !dd || !cb.checked) return;

    e.preventDefault();

    const idInput = form.querySelector('input[name="id"]');
    const mainId = idInput ? Number(idInput.value) : null;
    const mainQty = getQty(form);
    const gasketVariantId = Number(dd.value);

    if (!mainId || !gasketVariantId) return;

    try {
      await addItems([
        { id: mainId, quantity: mainQty },
        { id: gasketVariantId, quantity: 1, properties: { '_Add-on': 'Gasket' } }
      ]);

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = '/cart';

    } catch (err) {
      console.warn('Gasket add-on failed:', err);
      window.location.href = '/cart';
    }
  }, true);
})();

